export const WHATSAPP_BOOKING_URL = 'https://wa.me/421951074538';
